import * as Promise from 'bluebird'
import { Div, Element, Span, reactive, Variable } from 'alkali'
import * as _ from 'lodash'
import app from 'app/app'
import * as Bowser from 'bowser'
const isIE = navigator.userAgent.indexOf('Trident') > -1
import Loader from './Loader'
import Icon from 'components/Icon'
import * as closeIcon from 'icons/close.svg'
import { Velocity } from 'jquery'

//const { Velocity } = window.jQuery // when jQuery is detected, velocity attaches there

// An alkalized modal dialog that does not use any bootstrap js.
// Similar to other alkalized core components (Well and Widget), there is a
// head, body, and footer.
class Dialog extends Element('.modal-alkali', {
	style: {
		opacity: 0,
		display: 'none',
	},
}) {
	header: Header
	body: HTMLElement
	footer: Footer
	allowClose: boolean
	loading: Variable<boolean>
	loader: HTMLElement
	container: HTMLElement
	grid: any
	grids: any[]

	// Allows clicking on backdrop to close dialog
	get allowBackdropDismiss() {
		return true
	}

	get defaults() {
		return {}
	}

	static show(...args) {
		const dialog = new this(...args)

		dialog.show()

		return dialog
	}

	created(props) {
		_.merge(props, this.defaults)

		this.header = props.head ? new Header(props.head) : undefined
		if (this.header) {
			this.header.icons.append([
				this.header.close !== false
					? new Icon('.clickable', {
							icon: closeIcon,
							title: 'Close this dialog',
							onclick: e => this.hide(),
							tabIndex: 0,
						})
					: undefined,
			])
		}

		this.body = new Div('.modal-body')

		this.footer = props.foot ? new Footer(props.foot) : undefined
		if (this.footer) {
			this.footer.rightControls.append([
				// close is on by default
				this.footer.close
					? Div('.btn.btn-gray.btn-sm.close-btn', {
							textContent: 'Close',
							classes: {
								disabled: this.allowClose !== undefined ? !this.allowClose : false,
							},
							onclick: e => this.hide(),
							tabIndex: 0,
					  })
					: undefined,
			])
		}

		// Disable interaction with the dialog, similar to widget loader
		this.loading = reactive(props.loader || false)
		this.container = new Div(
			'.modal-dialog',
			{
				style: props.size ? `width: ${props.size}` : '',
			},
			[
				this.header,
				this.body,
                this.footer,
				(this.loader = new Loader('.modal-loader', { loading: this.loading })),
			]
		)

		this.append([
			Div('.modal-alkali-backdrop', {
				onclick: e => {
					if (this.allowBackdropDismiss || (app && app.isDebug)) this.hide()
				},
			}),
			this.container,
		])

		this.grids = []
	}

	// We need an explicit visibility getter because:
	// - velocity always restarts the animation
	// - we don't want to re-append or remove
	get isVisible() {
		return this.style.display !== 'none'
	}

	// Animation is seperated out to allow us to have instantaneous dialogs
	show(...args) {
		if (this.isShowing)
			return
		this.isShowing = true
		if (isIE) {
			$(document.body).addClass('showing-dialog')
		}
		return new Promise((resolve, reject) => {
			if (this.isVisible) return resolve()
			this.animateShow().then(() => resolve())
		}).then(result => {
			this.isShowing = false
			this.onShown(result)
		})
	}
	isShowing: boolean

	onShown(...args) {
		this.body.focus()
	}

	onHide() {}

	animateShow() {
		return new Promise((resolve, reject) => {
			// this.style.display = ''
			// document.body.append(this)
			// resolve()
			Velocity(this, 'fadeIn', {
				duration: 200,
				begin: () => document.body.append(this),
				complete: () => resolve(),
			})
		})
	}

	hide(...args) {
		if (isIE) {
			$(document.body).removeClass('showing-dialog')
		}
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				if (this.isVisible === false) return resolve()
				this.animateHide().then(() => resolve(this.onHide()))
			}, 1)
		})
	}
	animateHide() {
		return new Promise((resolve, reject) => {
			// this.style.display = 'none'
			// if (this.grid) this.grid.destroy()
			// this.remove ? this.remove() : this.parentNode.removeChild(this) // quick workaround for IE
			// resolve()
			Velocity(this, 'fadeOut', {
				duration: 150,
				complete: () => {
					if (this.grid) this.grid.destroy()
					if (this.grids?.length) this.grids.forEach(grid => grid.destroy())
					this.remove ? this.remove() : this.parentNode.removeChild(this) // quick workaround for IE
					resolve()
				},
			})
		})
	}
}

class Header extends Div.with('.modal-header') {
	info: HTMLElement
	controls: HTMLElement
	icons: HTMLElement
	titleText: any
	usersnap: boolean
	close: boolean

	created(props) {
		this.controls = new Div('.modal-controls')
		this.icons = new Div('.modal-icons')
		this.info = new Div('.modal-title', [
			props.icon ? Span(`.title-icon.fa.${props.icon}`) : undefined,
			Span('.title-text', {
				content: props.titleText || '',
			}),
		])
		this.append([this.info, this.controls, this.icons])
	}
}

class Footer extends Div.with('.modal-footer') {
	leftControls: HTMLElement
	rightControls: HTMLElement
	close: boolean
	save: boolean

	created(props) {
		this.leftControls = new Div('.footer-controls-left')
		this.rightControls = new Div('.footer-controls-right')
		this.append([this.leftControls, this.rightControls])
	}
}
export default Dialog.defineElement('doc-dialog')
